import React from "react";
import Loader from 'react-loader-spinner'
import HttpServices from "../../utils/Http.services";
// import { lngTranslations } from "../../utils/useful";
// import { transform } from "lodash";
// import SelectWithSearch from "./SelectWithSearch";
// import { imageAddress } from "../../utils/useful";



class MultiTreeSelectAddListing extends React.Component {

    state = {
        selected: '',
        subCheckCount: [],
        subCheck: [],
        choosen: [],
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: true,
        value: '',

    }

    toggleOpen = (makeOpen) => {

        let final = makeOpen != null ? makeOpen : !this.state.isOpen
        if (final != this.state.isOpen) {
            if (!this.state.isOpen) {
                document.addEventListener('mousedown', this.closeBox);
            } else {
                document.removeEventListener('mousedown', this.closeBox);
            }
        }
        // if (this.refs.icon)
        //     this.refs.icon.classList.toggle("rotate-180")


        this.setState({ isOpen: final, data: this.props.data }, () => {
            this.changePositionOnOpen()

        })

    }

    closeOptions() {
        document.removeEventListener('mousedown', this.closeBox);
        if (this.refs.icon)
            this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: false, data: this.props.data })
    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            if (this.refs.icon)
                this.refs.icon.classList.toggle("rotate-180")

        }
    }
    changeItem = (prop) => {
        // console.log("changeItem")

        // console.log(prop)
        // let title = typeof prop == 'object' ? prop.title : prop
        // this.search(prop.title)
        let choosen = []
        choosen.push(prop)
        this.setState({ value: '', isOpen: false })
        // this.closeOptions()
        if (this.state.tempData.length > 0) {
            this.setState({ options: this.state.tempData })
        }

        let parent = prop.parent?._id
        let parents = [prop.value]

        console.log(parent)
        this.getParent(parent, parents, () => {

            console.log(parents)
            this.setState({ choosen })

            this.props.changeValue(this.props.header.key, parents,)

        }, choosen)




    }


    getParent(parent, parents, cb, choosen) {

        if (parent == null) {
            parents = []
            cb()
        } else {
            let found = false

            let tempData = this.state.tempData
            if (tempData.length == 0) {
                tempData = this.state.options
            }
            tempData.forEach(element => {

                // console.log(element)

                if (element._id == parent) {

                    // console.log(element)
                    found = true
                    parents.splice(0, 0, element?._id)
                    choosen.splice(0, 0, element)

                    if (element.parent == null) {
                        cb()
                    } else {
                        this.getParent(element.parent?._id, parents, cb, choosen)
                    }
                }

            });

            if (found == false) {
                cb()
            }

        }
    }

    setDefault() {
        // console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaac',this.props.title);
        if ((Array.isArray(this.props.data) && this.props.data.length > 0)) {
            this.setState({ value: "" })
            let choosen = []
            this.state.options.forEach(option => {
                // console.log(option)
                let dataId = this.props.data[this.props.data.length - 1]?._id ?? this.props.data[this.props.data.length - 1]
                if (option.value == dataId) {
                    // this.setState({ value: option.title })
                    choosen.push(option)
                    let parent = option.parent?._id
                    let parents = [option.value]

                    console.log(parent)
                    this.getParent(parent, parents, () => {

                        console.log(parents)
                        this.setState({ choosen })
                        this.props.changeValue(this.props.header.key, parents,)

                    }, choosen)
                    // this.props.onChange(this.props.headerkey, this.props.title, option.withOperator, option.flexible)
                    return
                }
            });



        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentWillMount() {
        // if(this.props.title){
        //     this.setState({value:this.props.title})
        // }
        this.init()

    }

    componentWillReceiveProps(newProp) {
        if (this.props.title != newProp.title || JSON.stringify(this.props.header?.information?.filter) != JSON.stringify(newProp.header?.information?.filter) ) {
            this.init()

        }
    }

    componentDidUpdate(prevProps) {
        // console.log('this.props.header?.information?.filter',this.props.header?.information?.filter);
        if (JSON.stringify(this.props.header?.information?.filter) != JSON.stringify(prevProps.header?.information?.filter) ) {
            this.init()

        }
    }

    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {
                this.setState({ options: this.props.header.information.items })
            } else if (this.props.header.information.type == "api") {
                this.fetch()
                // this.setState({data:[]})
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        // console.log(this.props.options.filter)

        let body = this.props.header.information.filter ?? {}

        // body.filter = this.props.options.filter

        // if (this.props.options.select) {
        //     body.select = this.props.options.select
        // }

        // if (this.props.options.sort) {
        //     body.sort = this.props.options.sort
        // }


        // console.log(this.props.options.address)
        if (Array.isArray(body.country) && body.country.length == 0) {

            delete body.country
        }
        if(body.country && body.country?._id){
            body.country=  body.country?._id
        }
        console.log('body =>>', body, this.props.header.information?.address)
        HttpServices.request(this.props.header.information?.address, body, (data, fetchError) => {


            // console.log('body =>>',data)
            console.log(fetchError)

            // this.setState({ isLoading: false })

            if (fetchError) {
                this.setState({ fetchError })

                return
            }
            // console.log('c============================', data)



            var newData = []
            data.info.forEach(element => {


                let newTitle = this.spliter(element, this.props.header.information.fields.title)
                let newValue = this.spliter(element, this.props.header.information.fields.value)
                let newParent = this.spliter(element, this.props.header.information.fields.parent)
                let withOperator = this.spliter(element, 'withOperator')
                let flexible = this.spliter(element, 'flexible')
                let translations
                if (element['**translations']) {
                    translations = this.spliter(element, '**translations')
                    Object.keys(translations).forEach(translation => {
                        translations[translation]['title'] = translations[translation]['name']
                    })
                }

                let newImage = null
                if (this.props.header.information.fields.image) {
                    newImage = this.spliter(element, this.props.header.information.fields.image)
                }


                newData.push({ value: newValue, title: newTitle, image: newImage, parent: newParent, _id: element._id, withOperator, flexible, '**translations': translations })
            });

            // console.log(newData)



            this.setState({
                options: newData,
                tempData: newData,
            }, () => {
                this.setDefault()
                this.countCalculator()
                setTimeout(() => {
                    this.setState({isLoading:false})
                }, 1000);
            })
        })

        // fetch(this.props.options.address, {
        //     method: 'POST',
        //     body: JSON.stringify(body),
        //     headers: headers
        // }).then(response => response.json()).then(data => {
        //     if (data.status == 200) {
        //         // console.log(data)
        //         let newData = []
        //         console.log("this.props.options.fields");
        //         console.log(this.props.options.fields);
        //         data.info.forEach(element => {

        //             let newTitle = this.spliter(element, this.props.options.fields.title)
        //             let newValue = this.spliter(element, this.props.options.fields.value)
        //             let newParent = this.spliter(element, this.props.options.fields.parent)
        //             let withOperator = this.spliter(element, 'withOperator')
        //             let flexible = this.spliter(element, 'flexible')

        //             let newImage = null
        //             if (this.props.options.fields.image) {
        //                 newImage = this.spliter(element, this.props.options.fields.image)
        //             }


        //             newData.push({ value: newValue, title: newTitle, image: newImage, parent: newParent, _id: element._id, withOperator, flexible })
        //         });


        //         this.setState({
        //             options: newData,
        //             tempData: newData,
        //             isLoading: false
        //         }, () => {
        //             this.setDefault()
        //         })
        //     }

        // })
    }


    spliter(source, string) {
        if(source.name.includes('Back')){
            console.log('elementtttt',source);
        }
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        if(source.name.includes('Back')){
            console.log('elementtttt111',finalString);
        }
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        // console.log(value)
        this.toggleOpen(true)

        let options = this.state.tempData


        if (value == "") {
            await this.setState({ options: this.state.tempData, searchOptions: null })
            await this.setState({ tempData: [], isSearching: false })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
                options = this.state.options
            }
            var values = []
            // let options = this.state.tempData
            // var values = this.props.data.filter((e) => e.title === value)
            options.forEach(element => {
                if ((element.title && element.title.toLowerCase().includes(value.toLowerCase()))) {

                    let found = false

                    options.forEach(child => {
                        if (child.parent?._id == element._id) {
                            // console.log("found")
                            // console.log(element.title)

                            found = true
                        }
                    });

                    if (found == false) {
                        values.push(element)
                    }
                }
            })
            // console.log(values)

            this.setState({ options: values, isSearching: true })
            this.setState({ searchOptions: values })

            // }
        }
    }



    componentDidMount() {
        window.addEventListener('scroll', this.changePositionOnOpen, true);
        window.addEventListener('resize', this.changePositionOnOpen, true);

    }


    componentWillUnmount() {

        // this.window.removeEventListener('scroll', this.changePositionOnOpen, true);
        // this.window.removeEventListener('resize', this.changePositionOnOpen, true);

        if (this.unlisten)
            this.unlisten();
    }



    setWrapperRef(node) {
        this.wrapperRef = node;
    }



    changePositionOnOpen = () => {
        // console.log("SCROLL")
        if (this.wrapperRef) {
            let bounds = this.wrapperRef.getBoundingClientRect()
            // console.log("bounds")

            // console.log(bounds)

            if (this.refs.box) {
                let boxBounds = this.refs.box.getBoundingClientRect()
                // console.log("boxBounds")

                // console.log(boxBounds)


                this.setState({ top: bounds.y + bounds.height, width: bounds.width, left: bounds.x }, () => {
                    // console.log(this.state.top)
                })
            }
        }
        // console.log(this.wrapperRef.getBoundingClientRect())
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }
    showSub(prop) {

        this.state.subCheck[prop._id] = !this.state.subCheck[prop._id] ?? true;
        this.setState({ subCheck: this.state.subCheck })
    }



    countCalculator() {

        // if (this.state.tempData.length > 0)
        //     this.setState({ options: this.state.tempData })


        for (let i in this.state.options) {
            let id = this.state.options[i]._id
            if ((typeof (this.state.subCheckCount[this.state.options[i]._id]) == 'number')) {
                break;
            }
            for (let j in this.state.options) {
                if (this.state.options[j].parent?._id == id) {
                    this.state.subCheckCount[id] = 1;
                    this.setState({ subCheckCount: this.state.subCheckCount });
                    break;

                }
            }
        }
        // console.log((this.state.tempData.length))
    }

    liActive(id) {
        let l = [];
        l[id] = true;


        this.setState({ brandCheck: l });
    }

    selectedMnu(id) {

        // this.state.selected = [];
        // this.state.selected[id] = 1;
        // console.log('aaaaaaaaaaaaaaa', this.state.selected)
        this.setState({ selected: id })
    }


    modelNotListed = () => {
        this.props.modelNotListed()
    }


    loadRow(parent, paddingLeft) {

        // console.log(parent)

        
        return this.state.options.map((prop, index) => {
            let letShow = false
            let mparent = prop.parent?._id ?? prop.parent
            // console.log('prop==================',prop)

            if(prop.title.includes('Back')){
                console.log('elementtttt2222',prop);
            }
            if (mparent == '' || mparent == null) {
                let parents = this.state.options.filter((a) => { return ((String(a._id) == String(mparent)) && a.parent != null) })
                // console.log(parents)
                // console.log("PARENTS")
                if (parents.length == 0) {
                    letShow = false
                }
            }
            if ((this.state.searchOptions != null)) {
                letShow = true
            }

            if ((mparent == parent)) {
                letShow = true
            }

            if (this.state.subCheckCount[prop._id] && this.state.isSearching) {
                letShow = false
            }


            if (letShow) {
                return (
                    <div style={{ paddingLeft: paddingLeft, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>

                        {/* <img src="/new/close.png" width="30px" onClick={() => this.showSub(prop)} /> */}
                        <div className="select-item-addlisting" key={index} style={{ backgroundColor: (this.state.selected == prop._id) ? '#FFF3DB' : '#fff', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: paddingLeft == 0 ? '1px solid #f2f4f6' : 'none', borderRight: 0, paddingTop: '10px', paddingBottom: '10px' }}>
                            <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: (paddingLeft / 2) }}>
                                <div className="flexc" onClick={() => { if (!this.state.subCheckCount[prop._id]) { this.changeItem(prop) } else { this.showSub(prop) } }} style={{ padding: '5px 10px 5px 20px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>

                                    <p className="d-flex flex-column" style={{ margin: 0, color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontSize: paddingLeft == 0 ? 14 : 12, fontWeight: this.state.subCheckCount[prop._id] ? 'normal' : '600', textAlign: 'left' }}>
                                        {prop.title}
                                        {/* {prop.title && <span style={{ fontSize: '0.7em', opacity: '0.8' }}>{prop.title}</span>} */}
                                    </p>
                                    <span className="text-small" style={{ color: '#ee5050', fontSize: '0.9em' }}>{this.props.header.information.page == 'buy' ? '' : prop.withOperator ? "[With operator]" : ''}</span>
                                    <p className="mr-2" height={(this.state.subCheck[prop._id]) ? 14 : 12} style={{ display: (this.state.subCheckCount[prop._id]) ? '' : 'none', objectFit: 'contain', cursor: 'pointer' }} onClick={() => this.showSub(prop)} >{this.state.subCheck[prop._id] ? '-' : '+'}</p>
                                </div>

                                {/* <img className="mr-2" height={(this.state.subCheck[prop._id]) ? 14 : 12} style={{ display: (this.state.subCheckCount[prop._id]) ? '' : 'none', objectFit: 'contain', cursor: 'pointer' }} src={(this.state.subCheck[prop._id]) ? '/new/upPick.png' : '/new/downPick.png'} onClick={() => this.showSub(prop)} /> */}


                            </div>
                        </div>
                        {/* {console.log(this.loadRow(prop._id, paddingLeft + 10))} */}
                        {/* {this.state.searchOptions == null &()} */}
                        {this.state.subCheck[prop._id] && this.state.searchOptions == null && this.loadRow(prop._id, paddingLeft + 8)}



                    </div>
                )
            }
        })
    }



    render() {

        return (
            <div ref={ref => this.setWrapperRef(ref)} className='' style={{ paddingRight: 2, paddingTop: 2, width: '100%', minWidth: '200px', position: 'relative' }} >
                {/* {this.countCalculator()} */}

                <div onClick={() => { if (this.refs.input) this.refs.input.focus() }} style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', padding: 5, display: 'flex', backgroundColor: 'transparent', alignItems: 'center' }}>

                    {this.state.choosen.map((prop, index) => {
                        return (
                            <div className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                <div key={index} style={{ padding: 5, backgroundColor: '#78b2d020', borderRadius: 4, marginRight: 2, marginLeft: 2, display: 'flex', flexWrap: 'nowrap', alignItems: 'center', paddingLeft: 7, paddingRight: 7 }}>
                                    <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{prop.title}</p>
                                    {/* <img onClick={() => this.removeItem(index)} src={'/images/close.svg'} height="8px" /> */}
                                    {/* <i className="fa fa-times"  style={{ padding: 2, paddingLeft: 0, color: '#78b2d0' }}></i> */}
                                </div>
                                {index != this.state.choosen.length - 1 && (
                                    <img src={'/images/nexts.png'} height="15px" />
                                    // <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>
                                )}
                            </div>
                        )
                    })}
                    {this.state.choosen.length > 0 && (
                    <img src={'/images/check.svg'} height="20px" />
                    // <i className="fa fa-check-circle ml-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>
                )}
                    <input disabled={this.conditionalSettings('disabled', true)} value={this.state.value} onFocus={() => this.toggleOpen(true)} placeholder={this.props.placeholder} onInput={event => { this.search(event.target.value); this.setState({ value: event.target.value }) }} className='mediumiransansfont ' defaultValue={this.state.title} style={{ color: '#323232', padding: 10, backgroundColor: 'transition', flex: 1, width: '100%', borderStyle: 'none', fontSize: 15 }} />
                    {this.state.isLoading && (
                                <div style={{ position: 'absolute', top: 1, left: 5 }}>
                                    <Loader
                                        type="Oval"
                                        color="rgba(0,122,255,1)"
                                        height="20"
                                        width="20"
                                    />
                                </div>
                            )}
                </div>
                {this.state.isOpen  && (

                    <div className="scroll-bug menuSld" ref={"box"} style={{ display: 'flex', flexDirection: 'column', top: this.state.top, left: this.state.left, position: 'fixed', width: this.state.width, zIndex: 40, paddingTop: 5 }}>


                        <div className={'row m-0'} style={{ display: 'flex', width: '100%', backgroundColor: '#ffffffff', backdropFilter: 'blur(10px)', borderColor: '#eee', borderRadius: 6, maxHeight: 400, overflow: 'auto', paddingTop: 5, paddingBottom: 15, backgroundColor: "#fff", borderRadius: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: '20px' }}>
                            {/* {this.props.isSearchable && (<input onChange={event => this.search(event.target.value)} placeholder={"Search ..."} style={{ fontSize: 13, textAlign: 'center', alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'mediumiransansfont'} />)} */}

                            {/* {this.state.options.map((prop, index) => { */}
                            {!this.state.isLoading && (

                                <div class={(this.props.twoPart ? 'col-8' : 'col-12 p-0')} style={{ display: 'flex', flexDirection: 'column', position: 'relative', left: (this.props.twoPart ? '15px' : 0), top: '0px' }}>

                                {this.loadRow(null, 0)}
                                {/* {this.countCalculator(null)} */}
                            </div>
                            )}







                            {this.state.options.length != 0 && this.props.twoPart && (
                                <div class='col-4 ' style={{ backgroundColor: '#F9F9F9', alignItems: 'center', border: '0px solid', position: 'sticky', top: "25px", padding: '20px', overflow: 'auto' }}>
                                    <div style={{ color: '#949A9E', backgroundColor: 'transparent', fontSize: '14px', fontWeight: '400', fontFamily: "Poppins", display: 'flex', alignItems: 'center' }}>
                                        <div style={{ paddingRight: '10px' }}>Select Model</div>
                                        <div style={{ fontSize: '10px', color: '#000', backgroundColor: '#FFF0BE', padding: '2px 8px 2px 8px', border: 0, borderRadius: '20px' }}>Fast Listing</div>
                                    </div>
                                    <br />
                                    <div style={{ color: '#0091FD', padding: '0 0 10px 10px' }}>
                                        + Model not listed
                                    </div>
                                    <div>
                                        {/* <ul style={{ marginLeft:'-20px'}}>
                                            {this.state.brands.map((item)=>{return(

                                                <li className="brand-list" onClick={() => this.liActive(item._id)} style={{ color: (this.state.brandCheck[item._id] == true) ? '#0091FD' : '#000' }}>
                                                    {item.brand}
                                                </li>
                                            )})}
                                        </ul> */}
                                        {/* {console.log('this.state::',this.state.selected)} */}
                                        {/* <SelectWithSearch key={'model'} title={this.props.initData?.wiki} onChange={this.changeModel} options={{ searchPlaceholder: "Search Model ...", type: 'api', sort: { 'model': 1 }, fields: { value: '_id', title: 'model' }, address: 'getfilteredWikis', filter: { sort: { 'model': 1 }, "category": '5fb3c322deecbc7d27c7315d', 'approved': true } }} /> */}


                                    </div>

                                </div>)}


                            {this.state.options.length == 0 && !this.state.isLoading && (
                                <div className="col-12">
                                    <p style={{ margin: 0, color: '#323232', opacity: 1, fontSize: 14, textAlign: 'center', backgroundColor: '#fff' }}>Found Nothing</p>
                                </div>
                            )}

                            {this.state.isLoading && (
                                <div className="flexcc py-3" style={{}}>
                                    <Loader
                                        type="Oval"
                                        color="rgb(255, 197, 0)"
                                        height="40"
                                        width="40"
                                    />
                                </div>
                            )}

                            {/* <div className=" text-center" style={{ marginTop: 15, backgroundColor: '#fff', fontSize: 14, color: '#949A9E', borderTop: "1px solid #949A9E50", position: 'sticky', bottom: "-20px", padding: "10px" }} >Don’t see your equipment category on the list? <button onClick={() => this.modelNotListed()} style={{ color: '#007aff', cursor: 'pointer' }}>Click here</button></div> */}



                        </div>

                    </div>


                )}



            </div>
        );
    }
}


export default MultiTreeSelectAddListing;
